const getEnvVariable = (name: string) => (window as any).__env?.[name] || process.env[name];
const isProductionMode = getEnvVariable('NODE_ENV') === 'production';

const common = {
    generateTestAttributes: getEnvVariable('REACT_APP_GENERATE_TEST_ATTRIBUTES') === 'true',
    // LVC-3190: records hand-made DOM mutations inside modal portals. Read at runtime, so it can be switched on
    // for an environment without a rebuild. Off everywhere unless explicitly enabled.
    tracePortalMutations: getEnvVariable('REACT_APP_TRACE_PORTAL_MUTATIONS') === 'true',
    appLandingUrl: getEnvVariable('REACT_APP_LANDING_URL'),
    gaMeasurementId: getEnvVariable('REACT_APP_GA_MEASUREMENT_ID'),
    logLevel: getEnvVariable('REACT_APP_LOG_LEVEL'),
    apiUrl: getEnvVariable('REACT_APP_API_URL') || '/api',
    fileServerApiUrl: getEnvVariable('REACT_APP_FILE_SERVER_API_URL') || '/api',
    webrtcServerApiUrl: getEnvVariable('REACT_APP_WEBRTC_SERVER_API_URL') || '/api',
    socketApiUrl: getEnvVariable('REACT_APP_SOCKET_API_URL') || '',
    isProductionMode,
    isDevelopmentMode: !isProductionMode
};

const localConfig = {
    ...common,
    googleCaptchaSiteKey: '6LeQEb0aAAAAAEDPBqKHNiOscnlEKrPqjJrhL0_U',
    tinymceKey: '7kwf7xkibkk0649arfz7uwc5qiuuxtgw3x65gnwsi9fiwtb9',
};

const prodConfig = {
    ...common,
    googleCaptchaSiteKey: '6LetEL0aAAAAACu-6nU6AqVD8gg5VYogUF66cLyp',
    tinymceKey: '7kwf7xkibkk0649arfz7uwc5qiuuxtgw3x65gnwsi9fiwtb9',
};

export const envConfig = isProductionMode ? prodConfig : localConfig;
